const STORAGE_KEY = "localAccountList";

export function getLocalAccounts() {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    const list = raw ? JSON.parse(raw) : [];
    return Array.isArray(list) ? list : [];
  } catch (e) {
    return [];
  }
}

export function setLocalAccounts(list) {
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list || []));
}

export function upsertLocalAccount(account) {
  if (!account || account.userId == null || account.userId === "") {
    return getLocalAccounts();
  }
  const list = getLocalAccounts();
  const idx = list.findIndex(
    (item) => String(item.userId) === String(account.userId)
  );
  const next = {
    ...(idx > -1 ? list[idx] : {}),
    ...account,
  };
  if (idx > -1) {
    list.splice(idx, 1, next);
  } else {
    list.push(next);
  }
  setLocalAccounts(list);
  return list;
}

export function removeLocalAccount(userId) {
  const list = getLocalAccounts().filter(
    (item) => String(item.userId) !== String(userId)
  );
  setLocalAccounts(list);
  return list;
}
